import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { SocialModule } from '@tytapp/social';
import { TopicsModule } from '@tytapp/topics';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { TopicFeedItemComponent } from './topic-feed-item/topic-feed-item.component';
import { TopicFeedPageComponent } from './topic-feed-page/topic-feed-page.component';
import { TopicsIndexComponent } from './topics-index/topics-index.component';
import { ChatModule } from '@tytapp/chat';

@NgModule({
    declarations: [
        TopicsIndexComponent,
        TopicFeedPageComponent,
        TopicFeedItemComponent
    ],
    imports: [
        CommonModule,
        TYTCommonModule,
        CommonUiModule,
        ChatModule,
        TopicsModule,
        MatIconModule,
        MatButtonModule,
        SocialModule,
        RouterModule.forChild([
            { path: ':topic', component: TopicFeedPageComponent },
            { path: '', component: TopicsIndexComponent }
        ])
    ]
})
export class TopicPagesModule {

}